import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { logger } from '../../../../utils/logger';
import { shouldIgnoreStaleLiveCall } from '../../../agent-widget/acw-ui-lock';
import { CXoneEventsSubscriptionContext, EventSubscription } from '../../subscription-context';
import { mapVoiceCallStatus } from '../../map-voice-call-status';
import { coalesceCallStatus } from '../call-contact-mapping.util';
import {
  attachRemoteAudioStream,
  handleAutoAcceptCall,
  markAgentLegActiveWhenCallReady,
} from './call-status-handlers';
import { subscribeVoiceConnectionEvents } from './connection-subscription';

export function subscribeVoiceEvents(
  voiceClient: CXoneVoiceClient,
  ctx: CXoneEventsSubscriptionContext
): EventSubscription[] {
  const subscriptions = subscribeVoiceConnectionEvents(voiceClient, ctx);

  if (voiceClient.onCallStatusChanged) {
    const voiceCallSub = voiceClient.onCallStatusChanged.subscribe((voiceCall) => {
      logger.debug('[Events] Voice call status:', voiceCall);

      if (!voiceCall) {
        return;
      }

      const mappedStatus = mapVoiceCallStatus(voiceCall.status);
      if (!mappedStatus) {
        return;
      }
      if (
        mappedStatus !== 'idle' &&
        mappedStatus !== 'disconnected' &&
        shouldIgnoreStaleLiveCall(ctx.callStateRef.current.contactId)
      ) {
        logger.debug('[Events] Ignoring stale voice status during ACW:', voiceCall.status);
        return;
      }

      ctx.setCallState((prev) => ({
        ...prev,
        status: coalesceCallStatus(prev.status, mappedStatus),
      }));

      const isWebRtcConnected = voiceCall.status === 'CallShowStreams';

      if (isWebRtcConnected) {
        handleAutoAcceptCall(ctx);
        markAgentLegActiveWhenCallReady(ctx);
      }

      if (voiceCall.status === 'CallShowStreams' && ctx.audioRef?.current) {
        attachRemoteAudioStream(ctx, voiceCall.remoteStream as MediaStream | undefined);
      }
    });
    subscriptions.push(voiceCallSub);
  }

  return subscriptions;
}
